// API endpoints used by login + Tài sản (Via / TKQC / BM / Fanpage) + header notifications
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/login',
    LOGOUT: '/api/logout',
    REFRESH: '/api/refresh',
    USER: '/api/user'
  },
  NOTIFICATIONS: {
    UNREAD_COUNT: '/api/notifications/unread-count',
    LIST: '/api/notifications',
    READ: (id) => `/api/notifications/${id}/read`
  },
  USERS: {
    LIST: '/api/users',
    CREATE: '/api/users',
    UPDATE: '/api/users',
    DELETE: '/api/users',
    WITH_ROLES: '/api/users/with-roles',
    ENSURE_SHIELD_CONFIG_ACCESS: '/api/users'
  },
  ROLES: {
    LIST: '/api/roles',
    CREATE: '/api/roles',
    UPDATE: '/api/roles',
    DELETE: '/api/roles',
    PERMISSIONS: '/api/permissions'
  },
  VIA_FACEBOOK: {
    LIST: '/api/via-facebook',
    CREATE: '/api/via-facebook',
    UPDATE: '/api/via-facebook',
    DELETE: '/api/via-facebook',
    EXPORT: '/api/via-facebook/export',
    CHECK_TOKEN: '/api/via-facebook'
  },
  FACEBOOK_OAUTH: {
    OAUTH_CONFIG: '/api/facebook/oauth-config',
    EXCHANGE_TOKEN: '/api/facebook/exchange-token'
  },
  AD_ACCOUNTS: {
    LIST: '/api/v1/ad-accounts',
    EXPORT: '/api/v1/ad-accounts/export',
    HIDE: '/api/v1/ad-accounts/hide',
    RENTAL_STATUS: '/api/v1/ad-accounts/rental-status',
    CS_GROUP: '/api/v1/ad-accounts/cs-group',
    UPDATE_LONG_ID: '/api/v1/ad-accounts',
    INSIGHTS: '/api/v1/ad-accounts/insights',
    CHECK_NOT_IN_SYSTEM: '/api/v1/ad-accounts/check-not-in-system',
    VIAS: '/api/v1/ad-accounts'
  },
  SYSTEM_SETTINGS: {
    MISSING_ACCOUNTS: '/api/system-settings/missing_accounts'
  },
  BUSINESS_MANAGERS: {
    LIST: '/api/v1/business-managers',
    EXPORT: '/api/v1/business-managers/export',
    HIDE: '/api/v1/business-managers/hide',
    RENTAL_STATUS: '/api/v1/business-managers/rental-status',
    CS_GROUP: '/api/v1/business-managers/cs-group'
  },
  FANPAGE: {
    LIST: '/api/v1/fanpages',
    SUMMARY: '/api/v1/fanpages/summary',
    EXPORT: '/api/v1/fanpages/export',
    REFRESH: '/api/v1/fanpages/refresh',
    TRASH: '/api/v1/fanpages/trash',
    BLACKLIST: '/api/v1/fanpages/blacklist',
    RENTAL_STATUS: '/api/v1/fanpages/rental-status',
    CS_GROUP: '/api/v1/fanpages/cs-group',
    UPDATE_TAGS: (pageId) => `/api/v1/fanpages/${pageId}/tags`
  },
  CS_GROUPS: {
    LIST: '/api/v1/cs-groups',
    USERS: '/api/v1/cs-groups/users',
    CREATE: '/api/v1/cs-groups',
    UPDATE: (groupId) => `/api/v1/cs-groups/${groupId}`,
    DELETE: (groupId) => `/api/v1/cs-groups/${groupId}`,
    UPDATE_TELEGRAM_USERNAME: (userId) => `/api/v1/cs-groups/users/${userId}/telegram-username`
  },
  TAG_GROUPS: {
    LIST: '/api/v1/tag-groups',
    CREATE: '/api/v1/tag-groups',
    UPDATE: '/api/v1/tag-groups',
    DELETE: '/api/v1/tag-groups'
  },
  TAGS: {
    LIST: '/api/v1/tags',
    DETAIL: '/api/v1/tags',
    CREATE: '/api/v1/tags',
    UPDATE: '/api/v1/tags',
    DELETE: '/api/v1/tags'
  },
  TELE_SHARE: {
    INVENTORY: '/api/v1/tele-share/inventory',
    POLICY: '/api/v1/tele-share/policy',
    CS_LIMITS: '/api/v1/tele-share/cs-limits',
    CS_LIMIT: (id) => `/api/v1/tele-share/cs-limits/${encodeURIComponent(String(id))}`,
    GROUP_LIMITS: '/api/v1/tele-share/group-limits',
    GROUP_LIMIT: (id) => `/api/v1/tele-share/group-limits/${encodeURIComponent(String(id))}`,
    GROUP_LIMITS_BULK_BY_TIER: '/api/v1/tele-share/group-limits/bulk-by-tier',
    COMMANDS: '/api/v1/tele-share/commands',
    COMMANDS_EXPORT: '/api/v1/tele-share/commands/export',
    COMMAND: (id) => `/api/v1/tele-share/commands/${encodeURIComponent(String(id))}`,
    DAILY_USAGE_RESET: '/api/v1/tele-share/daily-usage/reset',
    QUOTA_PREVIEW: '/api/v1/tele-share/quota-preview',
    SETTINGS_BUNDLE: '/api/v1/tele-share/settings/bundle'
  },
  SHARE_PAGE: {
    POLICY: '/api/v1/tele-share-page/policy',
    DAILY_USAGE_RESET: '/api/v1/tele-share-page/daily-usage/reset',
    CS_LIMITS: '/api/v1/tele-share-page/cs-limits',
    CS_LIMIT: (id) => `/api/v1/tele-share-page/cs-limits/${encodeURIComponent(String(id))}`,
    GROUP_LIMITS: '/api/v1/tele-share-page/group-limits',
    GROUP_LIMIT: (id) => `/api/v1/tele-share-page/group-limits/${encodeURIComponent(String(id))}`,
    GROUP_LIMITS_BULK_BY_TIER: '/api/v1/tele-share-page/group-limits/bulk-by-tier',
    COMMANDS: '/api/v1/share-page/commands',
    COMMAND: (id) => `/api/v1/share-page/commands/${encodeURIComponent(String(id))}`,
    COMMANDS_EXPORT: '/api/v1/share-page/commands/export'
  },
  /** Admin Share Pixel — `/api/v1/tele-share-pixel` (permission aligned with tele-share-page). */
  TELE_SHARE_PIXEL: {
    POLICY: '/api/v1/tele-share-pixel/policy',
    DAILY_USAGE_RESET: '/api/v1/tele-share-pixel/daily-usage/reset',
    CS_LIMITS: '/api/v1/tele-share-pixel/cs-limits',
    CS_LIMIT: (id) => `/api/v1/tele-share-pixel/cs-limits/${encodeURIComponent(String(id))}`,
    GROUP_LIMITS: '/api/v1/tele-share-pixel/group-limits',
    GROUP_LIMIT: (id) => `/api/v1/tele-share-pixel/group-limits/${encodeURIComponent(String(id))}`,
    GROUP_LIMITS_BULK_BY_TIER: '/api/v1/tele-share-pixel/group-limits/bulk-by-tier',
    QUOTA_PREVIEW: '/api/v1/tele-share-pixel/quota-preview',
    SETTINGS_BUNDLE: '/api/v1/tele-share-pixel/settings/bundle',
    COMMANDS: '/api/v1/tele-share-pixel/commands',
    COMMAND: (id) => `/api/v1/tele-share-pixel/commands/${encodeURIComponent(String(id))}`,
    COMMANDS_EXPORT: '/api/v1/tele-share-pixel/commands/export'
  },
  /** Admin Create Catalogue — `/api/v1/tele-share-catalogue` (same permission as tele-share-pixel). */
  TELE_SHARE_CATALOGUE: {
    POLICY: '/api/v1/tele-share-catalogue/policy',
    DAILY_USAGE_RESET: '/api/v1/tele-share-catalogue/daily-usage/reset',
    CS_LIMITS: '/api/v1/tele-share-catalogue/cs-limits',
    CS_LIMIT: (id) => `/api/v1/tele-share-catalogue/cs-limits/${encodeURIComponent(String(id))}`,
    GROUP_LIMITS: '/api/v1/tele-share-catalogue/group-limits',
    GROUP_LIMIT: (id) => `/api/v1/tele-share-catalogue/group-limits/${encodeURIComponent(String(id))}`,
    GROUP_LIMITS_BULK_BY_TIER: '/api/v1/tele-share-catalogue/group-limits/bulk-by-tier',
    QUOTA_PREVIEW: '/api/v1/tele-share-catalogue/quota-preview',
    SETTINGS_BUNDLE: '/api/v1/tele-share-catalogue/settings/bundle',
    COMMANDS: '/api/v1/tele-share-catalogue/commands',
    COMMAND: (id) => `/api/v1/tele-share-catalogue/commands/${encodeURIComponent(String(id))}`,
    COMMANDS_EXPORT: '/api/v1/tele-share-catalogue/commands/export'
  },
  /** Admin Revoke Page — policy/limits dưới /tele-revoke-page; commands đã chuyển sang unified /revoke-page. */
  REVOKE_PAGE: {
    POLICY: '/api/v1/tele-revoke-page/policy',
    DAILY_USAGE_RESET: '/api/v1/tele-revoke-page/daily-usage/reset',
    CS_LIMITS: '/api/v1/tele-revoke-page/cs-limits',
    CS_LIMIT: (id) => `/api/v1/tele-revoke-page/cs-limits/${encodeURIComponent(String(id))}`,
    GROUP_LIMITS: '/api/v1/tele-revoke-page/group-limits',
    GROUP_LIMIT: (id) => `/api/v1/tele-revoke-page/group-limits/${encodeURIComponent(String(id))}`,
    GROUP_LIMITS_BULK_BY_TIER: '/api/v1/tele-revoke-page/group-limits/bulk-by-tier',
    COMMANDS: '/api/v1/revoke-page/commands',
    COMMAND: (id) => `/api/v1/revoke-page/commands/${encodeURIComponent(String(id))}`,
    COMMANDS_EXPORT: '/api/v1/revoke-page/commands/export'
  },
  SET_LIMIT: {
    COMMANDS: '/api/v1/set-limit/commands',
    COMMAND: (id) => `/api/v1/set-limit/commands/${encodeURIComponent(String(id))}`,
    COMMANDS_EXPORT: '/api/v1/set-limit/commands/export'
  },
  REMOVE_LIMIT: {
    COMMANDS: '/api/v1/remove-limit/commands',
    COMMAND: (id) => `/api/v1/remove-limit/commands/${encodeURIComponent(String(id))}`,
    COMMANDS_EXPORT: '/api/v1/remove-limit/commands/export'
  },
  RENAME_TKQC: {
    COMMANDS: '/api/v1/rename-tkqc/commands',
    COMMAND: (id) => `/api/v1/rename-tkqc/commands/${encodeURIComponent(String(id))}`,
    COMMANDS_EXPORT: '/api/v1/rename-tkqc/commands/export',
    KEYWORD_BLACKLIST: '/api/v1/rename-tkqc/keyword-blacklist',
    KEYWORD_BLACKLIST_ITEM: (id) => `/api/v1/rename-tkqc/keyword-blacklist/${encodeURIComponent(String(id))}`
  },
  RENAME_PAGE: {
    COMMANDS: '/api/v1/rename-page/commands',
    COMMAND: (id) => `/api/v1/rename-page/commands/${encodeURIComponent(String(id))}`,
    COMMANDS_EXPORT: '/api/v1/rename-page/commands/export',
    KEYWORD_BLACKLIST: '/api/v1/rename-page/keyword-blacklist',
    KEYWORD_BLACKLIST_ITEM: (id) => `/api/v1/rename-page/keyword-blacklist/${encodeURIComponent(String(id))}`
  },
  SCANBM_ADMIN: {
    CONFIG: '/api/v1/scanbm-admin/config',
    BLACKLIST: '/api/v1/scanbm-admin/blacklist',
    BLACKLIST_ITEM: (bmId) => `/api/v1/scanbm-admin/blacklist/${encodeURIComponent(String(bmId))}`,
    CS_ASSET_PERMISSIONS: '/api/v1/scanbm-admin/cs-asset-permissions',
    CS_ASSET_PERMISSION: (uid) => `/api/v1/scanbm-admin/cs-asset-permissions/${encodeURIComponent(String(uid))}`,
    // CS limit đã chuyển sang unified /api/v1/scan-bm/cs-* (CsLimitCardV2 + csLimitService).
    // Lịch sử lệnh /scanbm dùng chung BotCommandLogController với slug 'scan-bm'.
    COMMANDS: '/api/v1/scan-bm/commands',
    COMMAND: (id) => `/api/v1/scan-bm/commands/${encodeURIComponent(String(id))}`,
    COMMANDS_EXPORT: '/api/v1/scan-bm/commands/export'
  },
  CHECKTKQC_ADMIN: {
    CONFIG: '/api/v1/checktkqc-admin/config',
    // CS limit đã chuyển sang unified /api/v1/check-tkqc/cs-* (CsLimitCardV2 + csLimitService).
    STATUS_SUGGESTIONS: '/api/v1/checktkqc-admin/status-suggestions',
    // Lịch sử lệnh /checktkqc dùng chung BotCommandLogController với slug 'check-tkqc'.
    COMMANDS: '/api/v1/check-tkqc/commands',
    COMMAND: (id) => `/api/v1/check-tkqc/commands/${encodeURIComponent(String(id))}`,
    COMMANDS_EXPORT: '/api/v1/check-tkqc/commands/export'
  }
}
